<script lang="ts" setup>
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import type { Ref } from 'vue';

// TODO объединить два компонента с крошками в один

const router = useRouter();
const routes = router.getRoutes();
const siteStore = useSiteStore();
const HOMEPAGE = {
  title: 'Главная',
  url: '/',
};

function getBreadcrumbs(currentRoutePath: string): any[] {
  if (currentRoutePath === '') return [HOMEPAGE];

  const paths = getBreadcrumbs(currentRoutePath.slice(0, currentRoutePath.lastIndexOf('/')));

  const matchedRoutes = routes.filter((r) => isMatchPathsPatterns(r.path, currentRoutePath));

  const matchedRoute =
    matchedRoutes.length > 1 ? matchedRoutes.find((r) => r.path === currentRoutePath) : matchedRoutes[0];

  return [
    ...paths,
    {
      url: currentRoutePath,
      title: matchedRoute?.meta?.breadcrumb || siteStore.currentPageBreadcrumb || '',
    },
  ];
}

function isMatchPathsPatterns(pathA: string, pathB: string) {
  const partsA = pathA.split('/');
  const partsB = pathB.split('/');

  if (partsA.length !== partsB.length) return false;

  return partsA.every((part: string, i: number) => part === partsB[i] || part.startsWith(':'));
}

const currentRoute = useRoute();
const breadcrumbs: Ref<Array<{ title: string; url: string }>> = ref([HOMEPAGE]);

watch(
  () => ({
    path: currentRoute.path,
    name: currentRoute.name,
    meta: currentRoute.meta,
    matched: currentRoute.matched,
  }),
  (route: RouteLocationNormalizedLoaded) => {
    if (route.path === '/') return;
    breadcrumbs.value = getBreadcrumbs(route.path);
  },
  { immediate: true },
);

useJsonld({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs?.value.slice(1).map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: { '@id': index === breadcrumbs.value.length - 1 ? null : item.url, name: item.title },
  })),
});
</script>

<template>
  <ul class="breadcrumbs-block">
    <li
      v-for="(item, key) in breadcrumbs"
      :key="item.title"
      class="breadcrumbs-block__item"
    >
      <AppLink
        :to="key === breadcrumbs.length - 1 ? '' : item.url"
        class="text-hell-black last-of-type:break-words mb-0.5"
      >
        {{ item.title }}
      </AppLink>

      <SvgoChevronRight
        v-if="key !== breadcrumbs.length - 1"
        class="text-xs text-hell-black-60 mb-0.5"
        filled
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.breadcrumbs-block {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  font-size: $text-xs;

  &__item {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  a {
    text-decoration: none;
  }
}
</style>
